module.exports = __webpack_public_path__ + "img/71f2bb1.jpg";